export default __webpack_public_path__ + "static/media/AdobeStock_219471483.1d1ed5cc.jpg";